//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA LOAD INTEGRAÇÕES ---------------//
// Responsável por carregar as integrações via API
export default async function loadIntegrationsService() {
  try {
    const response = await api.get("/integracoes");
    return response;
  } catch (err) {
    console.error("❌ Erro ao carregar integrações:", err);
    toast.error("Erro ao carregar integrações");
    return [];
  }
}